export const InvoiceFormats = {
  PDF: 'PDF',
  XLSX: 'XLSX',
  ZIP: 'ZIP',
} as const;

export type InvoiceFormat = typeof InvoiceFormats[keyof typeof InvoiceFormats];
